import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, Table, Space, message, Modal, Switch } from 'antd';
import { SearchOutlined, ReloadOutlined, DeleteOutlined, PlusOutlined, EditOutlined, TrademarkCircleOutlined, BulbOutlined } from '@ant-design/icons';
import './index.css';
import apiClient from '../../utils/apiService';

const { Option } = Select;

function UsrManage() {
  const [form] = Form.useForm();
  const [createUserForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();



  // 状态管理
  const [userData, setUserData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [loading, setLoading] = useState(false);
  const [sortInfo, setSortInfo] = useState({ sortField: undefined, sortOrder: undefined });
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isDisableModalVisible, setIsDisableModalVisible] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentOperation, setCurrentOperation] = useState('');
  const [roleUpdateForm] = Form.useForm();
  const [isRoleUpdateModalVisible, setIsRoleUpdateModalVisible] = useState(false); // 添加这个状态
  const [roleDict, setRoleDict] = useState([]); // 添加角色字典状态



  // 表格列定义
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 100, align: 'center', fixed: 'left', sorter: true },
    { title: 'Username', dataIndex: 'username', key: 'username', width: 150, align: 'center', fixed: 'left', sorter: true },
    { title: 'First Name', dataIndex: 'firstName', key: 'firstName', width: 120, render: (text) => text || '-', sorter: true },
    { title: 'Last Name', dataIndex: 'lastName', key: 'lastName', width: 120, render: (text) => text || '-' },
    { title: 'Email', dataIndex: 'email', key: 'email', width: 200, render: (text) => text || '-' },
    { title: 'Employee No', dataIndex: 'employeeNo', key: 'employeeNo', width: 120, render: (text) => text || '-' },
    { title: 'Department Code', dataIndex: 'departmentCode', key: 'departmentCode', width: 150, render: (text) => text || '-' },
    { title: 'Company', dataIndex: 'companyName', key: 'companyName', width: 150, render: (text) => text || '-' },
    { title: 'User Role', dataIndex: 'userRole', key: 'userRole', width: 120, render: (text) => text || '-' },
    { title: 'Role Name', dataIndex: 'userRoleName', key: 'userRoleName', width: 150, render: (text) => text || '-' },
    { title: 'Data Scope', dataIndex: 'dataScope', key: 'dataScope', width: 120, render: (text) => text || '-' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (text) => (
        <span style={{ color: text === 1 ? 'green' : 'red' }}>
          {text === 1 ? 'Active' : 'Inactive'}
        </span>
      )
    },
    { title: 'Can Edit Finance', dataIndex: 'canEditFinance', key: 'canEditFinance', width: 150, render: (text) => text ? 'Yes' : 'No' },
    { title: 'Can Export', dataIndex: 'canExport', key: 'canExport', width: 120, render: (text) => text ? 'Yes' : 'No' },
    { title: 'Can Search All', dataIndex: 'canSearchAll', key: 'canSearchAll', width: 150, render: (text) => text ? 'Yes' : 'No' },
    { title: 'Edit Permission', dataIndex: 'editPermission', key: 'editPermission', width: 150, render: (text) => text || '-' },
    { title: 'Last Login Time', dataIndex: 'lastLoginTime', key: 'lastLoginTime', width: 180, render: (text) => text || '-' },
    { title: 'Created Time', dataIndex: 'createdTime', key: 'createdTime', width: 180, render: (text) => text || '-' },
    { title: 'Updated Time', dataIndex: 'updatedTime', key: 'updatedTime', width: 180, render: (text) => text || '-' },
    {
      title: 'Operation',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="default"
            icon={<EditOutlined />}
            size="small"
            onClick={() => showRoleUpdateModal(record)}
          />

          <Button
            type="default"
            size="small"
            icon={<BulbOutlined />}
            onClick={() => showToggleStatusModal(record)}
            style={{ color: record.status === 1 ? 'green' : 'red' }}
          >
            {/* {record.status === 1 ? 'Enable' : 'Disable'} */}
          </Button>

          <Button
            type="primary"
            danger
            ghost
            icon={<DeleteOutlined />}
            size="small"
            onClick={() => showDeleteModal(record)}
          >

          </Button>
        </Space>
      ),
      width: 180,
      fixed: 'right',
    },
  ];

  // 通用 API 调用函数
  const fetchData = async (url, method = 'get', data = {}) => {
    try {
      let response;
      if (method.toLowerCase() === 'get') {
        response = await apiClient.get(url, { params: data });
      } else {
        response = await apiClient[method](url, data);
      }
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
      messageApi.error(errorMessage);
      throw error;
    }
  };

  // 获取用户数据
  const loadUserData = async (page = 1, pageSize = 10, filters = {}, sort = {}) => {
    setLoading(true);
    try {
      const params = {
        pageNum: page,
        pageSize: pageSize,
        ...filters,
        ...(sort.sortField ? { sortField: sort.sortField, sortOrder: sort.sortOrder || 'ASC' } : {})
      };

      const response = await fetchData('/user-management/users', 'post', params);
      const { data } = response;

      if (data && data.records) {
        setUserData(data.records);
        setPagination({
          current: data.pageNum,
          pageSize: data.pageSize,
          total: data.total
        });
      } else {
        setUserData([]);
        setPagination({ current: 1, pageSize: 10, total: 0 });
      }
    } catch (error) {
      setUserData([]);
      setPagination({ current: 1, pageSize: 10, total: 0 });
      console.error('Failed to load user data:', error);
    } finally {
      setLoading(false);
    }
  };

  // 查询表单提交
  const handleSearch = (values) => {
    const filters = {};
    if (values.username) filters.username = values.username;
    if (values.email) filters.email = values.email;
    if (values.userRole) filters.userRole = values.userRole;
    if (values.status) filters.status = values.status;

    loadUserData(1, pagination.pageSize, filters);
  };

  // 重置表单
  const handleReset = () => {
    form.resetFields();
    loadUserData(1, pagination.pageSize);
  };

  // 显示删除确认弹窗
  const showDeleteModal = (user) => {
    setCurrentUser(user);
    setCurrentOperation('delete');
    setIsDeleteModalVisible(true);
  };

  // 显示禁用确认弹窗
  const showDisableModal = (user) => {
    setCurrentUser(user);
    setCurrentOperation('disable');
    setIsDisableModalVisible(true);
  };

  // 显示创建用户弹窗
  const showCreateModal = () => {
    createUserForm.resetFields();
    setIsCreateModalVisible(true);
  };

  
  // 创建用户
  const handleCreateUser = async (values) => {
    try {
      const response = await fetchData('/user-management/create-user', 'post', values);
      if (response.code === 200 && response.data) {
        messageApi.success(response.message || 'Create Success');
        setIsCreateModalVisible(false);
        loadUserData(pagination.current, pagination.pageSize);
      } else {
        messageApi.error(response.message || 'Create Failed');
      }
    } catch (error) {
      console.error('Failed to create user:', error);
    }
  };


  // 弹窗
  const showRoleUpdateModal = (user) => {
    setCurrentUser(user);
    setCurrentOperation('update-role');

    // 设置默认值
    roleUpdateForm.setFieldsValue(user);

    setIsRoleUpdateModalVisible(true);
  };
  // 处理更新用户信息
  const handleUpdateUserInfo = async (values) => {
    try {
      const response = await fetchData(`/user-management/users/${currentUser.id}`, 'put', values);
      if (response.code === 200) {
        messageApi.success('Update Success');
        setIsRoleUpdateModalVisible(false);
        loadUserData(pagination.current, pagination.pageSize);
      }
    } catch (error) {
      console.error('Failed to update user info:', error);
    }
  };



  // 启用/禁用用户
  const handleToggleUserStatus = async (userId, status) => {
    try {
      let response;
      if (status === 1) { // 当前状态为激活，需要禁用
        response = await fetchData(`/user-management/users/${userId}/disable`, 'put');
      } else { // 当前状态为禁用，需要启用
        response = await fetchData(`/user-management/users/${userId}/enable`, 'put');
      }

      if (response.code === 200) {
        messageApi.success(status === 1 ? 'User disabled successfully' : 'User enabled successfully');
        setIsDisableModalVisible(false);
        loadUserData(pagination.current, pagination.pageSize);
      }
    } catch (error) {
      console.error('Failed to toggle user status:', error);
    }
  };

  const showToggleStatusModal = (user) => {
    setCurrentUser(user);
    setCurrentOperation('toggle-status');
    setIsDisableModalVisible(true);
  };

  // 删除用户
  const handleDeleteUser = async () => {
    try {
      await fetchData(`/user-management/users/${currentUser.id}`, 'delete');
      messageApi.success('User deleted successfully');
      setIsDeleteModalVisible(false);
      loadUserData(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error('Failed to delete user:', error);
    }
  };



    // 加载角色字典
  const loadRoleDict = async () => {
    try {
      const response = await fetchData('/user-management/role-permissions/dict', 'get');
      if (response.code === 200 && response.data) {
        setRoleDict(response.data);
      } else {
        setRoleDict([]);
      }
    } catch (error) {
      console.error('Failed to load role dictionary:', error);
      setRoleDict([]);
    }
  };

  // 渲染角色选项
  const renderRoleOptions = () => {
    return roleDict.map((role) => (
      <Option key={role.value} value={role.value}>
        {role.label || ''}
      </Option>
    ));
  };



  useEffect(() => {
    loadUserData();
    loadRoleDict(); // 加载角色字典
  }, []);
  return (
    <div className="usrManage-container">
      {contextHolder}

      {/* 查询表单 */}
      <div className="usrManage-search-form">
        <Form form={form} name="search" onFinish={handleSearch} layout="vertical">
          <div className="form-items">
            <Form.Item name="username" label="Username" className="form-item">
              <Input placeholder="Input Username" allowClear />
            </Form.Item>
            <Form.Item name="email" label="Email" className="form-item">
              <Input placeholder="Input Email" allowClear />
            </Form.Item>
            <Form.Item name="userRole" label="User Role" className="form-item">
              <Select allowClear placeholder="Select Role">
                {renderRoleOptions()}
              </Select>
            </Form.Item>
            <Form.Item name="status" label="Status" className="form-item">
              <Select
                options={[
                  { value: '1', label: 'Active' },
                  { value: '0', label: 'Inactive' },
                ]}
                allowClear
              />
            </Form.Item>
          </div>
          <div className="form-buttons">
            <Space>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                Search
              </Button>
              <Button
                onClick={handleReset}
                icon={<ReloadOutlined />}
              >
                Reset
              </Button>
            </Space>
          </div>
        </Form>
      </div>

      {/* 数据表格 */}
      <div className="usrmanage-table">
        <Button style={{ marginBottom: 10 }} type="primary" onClick={showCreateModal} icon={<PlusOutlined />}>
          Create User
        </Button>

        <Table
          className='usrmanage-table-table'
          columns={columns}
          size='small'
          dataSource={userData.map((item) => ({ ...item, key: item.id }))}
          pagination={{
            ...pagination,
            onChange: (page, pageSize) => {
              const formValues = form.getFieldsValue();
              const filters = {};
              if (formValues.username) filters.username = formValues.username;
              if (formValues.email) filters.email = formValues.email;
              if (formValues.userRole) filters.userRole = formValues.userRole;
              if (formValues.status) filters.status = formValues.status;

              loadUserData(page, pageSize, filters, sortInfo);
            },
          }}
          onChange={(pag, __, sorter) => {
            if (sorter && sorter.field) {
              const sortField = sorter.field || undefined;
              const sortOrder = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : undefined;
              const newSort = { sortField, sortOrder };
              setSortInfo(newSort);

              const formValues = form.getFieldsValue();
              const filters = {};
              if (formValues.username) filters.username = formValues.username;
              if (formValues.email) filters.email = formValues.email;
              if (formValues.userRole) filters.userRole = formValues.userRole;
              if (formValues.status) filters.status = formValues.status;

              loadUserData(pag.current, pag.pageSize, filters, newSort);
            }
          }}
          loading={loading}
          scroll={{ x: 'max-content', y: 420 }}
          style={{ maxWidth: '100%' }}
        />
      </div>

      {/* 删除确认弹窗 */}
      <Modal
        title="Confirm Delete"
        open={isDeleteModalVisible}
        onCancel={() => setIsDeleteModalVisible(false)}
        onOk={handleDeleteUser}
      >
        <p>Are you sure you want to permanently delete user "{currentUser?.username}" (ID: {currentUser?.id})? This action cannot be undone.</p>
      </Modal>

      {/* 禁用确认弹窗 */}
      <Modal
        title="Confirm Action"
        open={isDisableModalVisible}
        onCancel={() => setIsDisableModalVisible(false)}
        onOk={() => handleToggleUserStatus(currentUser.id, currentUser.status)}
      >
        <p>
          {currentUser?.status === 1
            ? `Are you sure you want to disable user "${currentUser?.username}" (ID: ${currentUser?.id})? This will prevent them from logging in.`
            : `Are you sure you want to enable user "${currentUser?.username}" (ID: ${currentUser?.id})? This will allow them to log in again.`}
        </p>
      </Modal>

      {/* 创建用户弹窗 */}
      <Modal
        title="Create New User"
        open={isCreateModalVisible}
        onCancel={() => setIsCreateModalVisible(false)}
        footer={
          <Space>
            <Button onClick={() => setIsCreateModalVisible(false)}>
              Cancel
            </Button>
            <Button type="primary" onClick={() => createUserForm.submit()}>
              Create
            </Button>
          </Space>
        }
        styles={{ body: { maxHeight: '60vh', overflowY: 'auto' } }}
      >
        <Form
          form={createUserForm}
          layout="vertical"
          onFinish={(values) => {
            handleCreateUser(values);
          }}
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please enter username' }]}
          >
            <Input placeholder="Enter Username" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: 'Please enter password' },
              { min: 6, message: 'Password must be at least 6 characters' },
            ]}
          >
            <Input.Password placeholder="Enter Password" />
          </Form.Item>

          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: 'Please enter first name' }]}
          >
            <Input placeholder="Enter First Name" />
          </Form.Item>

          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: 'Please enter last name' }]}
          >
            <Input placeholder="Enter Last Name" />
          </Form.Item>

          <Form.Item
            label="Telephone"
            name="telephone"
            rules={[{ required: true, message: 'Please enter telephone' }]}
          >
            <Input placeholder="Enter Telephone" />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input placeholder="Enter Email" />
          </Form.Item>

          <Form.Item
            label="Status"
            name="status"
            rules={[{ required: true, message: 'Please select status' }]}
          >
            <Select>
              <Option value={1}>Active</Option>
              <Option value={0}>Inactive</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="userRole"
            label="User Role"
            rules={[{ required: true, message: 'Please select a role' }]}
          >
            <Select>
              {renderRoleOptions()}
            </Select>
          </Form.Item>
        </Form>
      </Modal>


      {/* 更新用户信息弹窗 */}
      <Modal
        title={`Update User Info for ${currentUser?.username}`}
        open={isRoleUpdateModalVisible}
        onCancel={() => setIsRoleUpdateModalVisible(false)}
        onOk={async () => {
          try {
            const values = await roleUpdateForm.validateFields();
            // 将布尔值转换为数字值
            const processedValues = {
              ...values,
              canEditFinance: values.canEditFinance ? 1 : 0,
              canSearchAll: values.canSearchAll ? 1 : 0,
              canExport: values.canExport ? 1 : 0,
            };
            await handleUpdateUserInfo(processedValues);
          } catch (error) {
            console.error('表单验证失败:', error);
          }
        }}
        styles={{ body: { maxHeight: '60vh', overflowY: 'auto' } }}
      >
        <Form
          form={roleUpdateForm}
          layout="vertical"
          initialValues={{
            canEditFinance: currentUser?.canEditFinance === 1,
            canSearchAll: currentUser?.canSearchAll === 1,
            canExport: currentUser?.canExport === 1,
          }}
        >
          <Form.Item
            name="firstName"
            label="First Name"
            rules={[{ required: true, message: 'Please enter first name' }]}
          >
            <Input placeholder="Enter First Name" />
          </Form.Item>

          <Form.Item
            name="lastName"
            label="Last Name"
            rules={[{ required: true, message: 'Please enter last name' }]}
          >
            <Input placeholder="Enter Last Name" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              // { required: true, message: 'Please enter password' },
              { min: 4, message: 'Password must be at least 4 characters' },
            ]}
          >
            <Input.Password placeholder="Enter Password" />
          </Form.Item>

          <Form.Item
            name="telephone"
            label="Telephone"
            rules={[{ required: true, message: 'Please enter telephone' }]}
          >
            <Input placeholder="Enter Telephone" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input placeholder="Enter Email" />
          </Form.Item>

          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: true, message: 'Please select status' }]}
          >
            <Select>
              <Option value={1}>Active</Option>
              <Option value={0}>Inactive</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="userRole"
            label="User Role"
            rules={[{ required: true, message: 'Please select a role' }]}
          >
            <Select>
              {renderRoleOptions()}
            </Select>
          </Form.Item>

          <Form.Item
            name="canEditFinance"
            label="Can Edit Finance"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="canSearchAll"
            label="Can Search All"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            name="canExport"
            label="Can Export"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>


          <Form.Item
            label="Data Scope"
            name="dataScope"
            rules={[{ required: true, message: 'Please select a data scope' }]}
          >
            <Select>
              <Option value="ALL">ALL</Option>
              <Option value="SELF">SELF</Option>
              <Option value="SELF_NO_PIC">SELF_NO_PIC</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="editPermission"
            label="Edit Permission"
          >
            <Select>
              <Option value="EDIT_ALL">ALL</Option>
              <Option value="EDIT_SELF">EDIT SELF</Option>
              <Option value="READ_ONLY">READ ONLY</Option>
            </Select>
          </Form.Item>
        </Form>


      </Modal>
    </div>
  );
}

export default UsrManage;